module.exports = __webpack_public_path__ + "img/franchising_help_purchase2.2d9b99fd.png";